import React from 'react';
import { ClassAssembly3D2026 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly3D2026/>;
  };
  
  export default ClassAssemblyPage;